/** @format */

import React, { useEffect } from 'react';
import { useState } from 'react';
import db from '../firebase';
import './PlansScreens.css';
export function Plansscreens() {
	const [movies, setmovies] = useState([]);
	useEffect(() => {
		db.collection('movies')
			.where('active', '==', true)
			.get()
			.then((querySnapshot) => {
				const movies = {};
				querySnapshot.forEach(async (productDoc) => {
					movies[productDoc.id] = productDoc.data();
					const priceSnap = await productDoc.ref.collection('prices').get();

					priceSnap.docChanges.forEach((price) => {
						movies[productDoc.id].prices = {
							priceId: price.id,
							priceData: price.data(),
						};
					});
				});
				setmovies(movies);
			});
	}, []);
	return (
		<div className='planScreens'>
			{Object.entries(movies).map(([productID, productData]) => {
				return (
					<div className='planScreens_info'>
						<h5> Premum </h5>
						<h5>{productData.description}</h5>
					</div>
				);
			})}
		</div>
	);
}
export default Plansscreens;
